import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postParent = data => {
  return api.post(`admin/parent`, data);
};

export const usePostParentMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postParent,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
